import Support from '../../../settings/components/Support';

const SupportPage = () => {
    return <Support />;
};

export default SupportPage;
